import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where
} from "firebase/firestore";
import { db } from "../utils/firebase-config";
import type { StyleState } from "../reducers/StyleReducer";

/** A style config as stored in Firestore: the style slice plus owning uid. */
export type PersistedStyles = Partial<StyleState> & { uid: string };

export function createStyles(styles: PersistedStyles) {
  return addDoc(collection(db, "styles"), styles);
}

export function updateStyles(id: string, styles: PersistedStyles) {
  return updateDoc(doc(db, "styles", id), styles).then(() => undefined);
}

export function queryStylesByUid(uid: string) {
  return getDocs(query(collection(db, "styles"), where("uid", "==", uid)));
}
